import { object, string } from 'libs/form';
import { TFunc } from 'libs/i18n';

export const ISIN_LENGTH = 12;

export const getFinancialInstrumentSchema = (t: TFunc) =>
  object({
    isin: object({
      value: string().required(),
      label: string().required(),
    })
      .test('len', (val, ctx) => {
        if (val?.label && val?.label.length !== ISIN_LENGTH) {
          return ctx.createError({
            message: t('validation.length', { length: ISIN_LENGTH }),
          });
        }
        return true;
      })
      .required()
      .default(null),
    securityType: string().nullable(),
    issuer: string().nullable(),
    nominalValue: string().nullable(),
  });
